import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { IconButton } from '../Controls';
import { EditOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';

const ControlsActions = ({ actions, style, moveToTop = false }) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  const allowedActions = useMemo(() => {
    return (
      actions &&
      actions.filter((action) => {
        // Filter actions by permissions
        return (
          !action.permission ||
          (user && user.permissions && user.permissions[action.permission])
        );
      })
    );
  }, [actions, user]);

  if (!allowedActions || allowedActions.length === 0) {
    return null;
  }

  return (
    <div
      className={`controls-actions-wrapper-comp ${
        moveToTop ? 'move-to-top' : ''
      }`}
      style={style}
    >
      {allowedActions.map((action, index) => (
        <IconButton
          tooltip={action.tooltip}
          icon={<EditOutlined />}
          key={`action-${index}`}
          onClick={() => {
            if (action.to) {
              navigate(action.to, { state: { from: location } });
            } else {
              action.onClick();
            }
          }}
        />
      ))}
    </div>
  );
};

ControlsActions.propTypes = {
  actions: PropTypes.any, // [{permission: 'blocks.index', icon: 'edit', to: '/cms/news/1', tootlip: 'Upravit' onClick: () => showSomething()}]
  moveToTop: PropTypes.bool,
};

export default ControlsActions;
